import { Flex } from 'antd';

import BaseText from '@components/typography/BaseText';

const eyebrowStyle = { letterSpacing: 1.5, textTransform: 'uppercase' };

/** Placeholder shown in the details column while no taxonomy node is selected. */
const ObjectDetailsEmpty = () => (
	<Flex vertical align="center" gap={12} style={{ marginTop: 56, textAlign: 'center' }}>
		<BaseText type="secondary" size="xs" strong style={eyebrowStyle}>
			Object details
		</BaseText>
		<BaseText type="secondary" size="sm">
			Select an object to see its details,
			<br />
			or add a child to any node.
		</BaseText>
	</Flex>
);

export default ObjectDetailsEmpty;
